interface TableFilters {
  page?: number;
  limit?: number;
  sort?: string;
  order?: string;
  keyword?: string;
}

export const generateQueryParams = (filters: TableFilters): string => {
  // Build query string manually to avoid automatic encoding of special characters
  const params = new Array<string>();
  
  // Add required parameters
  params.push(`page=${filters.page || "1"}`);
  params.push(`limit=${filters.limit || "10"}`);
  params.push(`sort_column=${filters.sort || "id"}`);
  params.push(`sort=${filters.order || "desc"}`);
  
  // Add optional keyword parameter
  if (filters.keyword) {
    params.push(`keyword=${filters.keyword}`);
  }
  
  return params.join('&');
};